import { Form, Input } from "reactstrap";
import { AddNew, UploadFile } from "../../../Constant";
import { PlusSquare, Upload } from "react-feather";
import { Btn } from "../../../AbstractElements";
import { getFile, onFileUpload } from "../../../Redux-Toolkit/Reducers/FileManagerSlice";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import { ChangeEvent, useState } from "react";

export const FileContentButtonActions = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const dispatch = useAppDispatch();

  const onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) setSelectedFile(files[0]);
  };
  
  return (
    <div className="flex-grow-1 text-end">
      <Form className="d-inline-flex" method="POST" name="myForm">
        <Btn color="primary" onClick={() => dispatch(getFile())}><PlusSquare />{AddNew}</Btn>
        <div className="file-data">
          <Input id="upfile" type="file" multiple onChange={(e) => onFileChange(e)} />
        </div>
      </Form>
      <Btn outline color="primary" className="ms-2" onClick={() => dispatch(onFileUpload(selectedFile))}><Upload />{UploadFile}</Btn>
    </div>
  );
};
